



































import { defineComponent, PropType } from '@vue/composition-api';
import { HtmlString } from '@front-app/services/SharedModels';
import PlainTextUserContent from '@front-app/components/PlainTextUserContent.vue';
import { EditableSection } from '../editableProfileSections';
import ProfileCard from '../ProfileCard.vue';
import ProfileSubheader from '../ProfileSubheader.vue';

export default defineComponent({
	components: {
		ProfileCard,
		ProfileSubheader,
		PlainTextUserContent,
	},
	props: {
		isCurrentUserProfile: Boolean,
		summaryForAll: {
			type: String as unknown as PropType<HtmlString>,
			required: true,
		},
		summaryForContacts: {
			type: String as unknown as PropType<HtmlString>,
			required: true,
		},
	},
	setup() {
		return {
			EditableSection,
		};
	},
});
